import Page from "../../../layout/Page";

import {useTranslation} from "react-i18next";
import usePagination from "../../../util/usePagination";
import applicationService from "../../../service/ApplicationService";
import {DataTable} from "../../../components/DataTable";
import Container from '@mui/material/Container';
import ListPageActions from "../../../components/ListPageActions";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import AddButton from "../../../ui/AddButton";
import DeleteDialog from "../../../components/DeleteDialog";

const ApplicationListPage = ({title}) => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [selected, setSelected] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const columns = [

        {
            name: "name",
            label: t('label.name'),
            searchable: true
        },
        {
            name: "code",
            label: t('label.code')
        }
    ];

    const applications = usePagination({
        service: applicationService
    })

    const ActionButtons = () => (
        <ListPageActions>
            <AddButton onClick={() => {
                navigate(`/commons/applications/create`)
            }}/>
        </ListPageActions>
    )

    return (
        <Page title={title}>
            <Container maxWidth={"md"}>
                <ActionButtons/>
                <DataTable
                    title={t('title.applicationList')}
                    columns={columns} {...applications}
                    onEdit={(item) => {
                        navigate(`/commons/applications/edit/${item._id}`);
                    }}
                    onDelete={(item) => {
                        setSelected(item);
                        setOpenDeleteDialog(true);
                    }}
                />
                <ActionButtons/>
            </Container>

            <DeleteDialog
                item={selected}
                itemService={applicationService}
                message={selected?.name}
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                    setSelected(null)
                }}
                onDoneCallback={applications.search}
            />
        </Page>
    );
}

export default ApplicationListPage;
